import React from 'react';

type LtaBadgeVariant = 'premium_plus' | 'premium';

interface LtaBadgeIconProps {
  variant?: LtaBadgeVariant;
}

/**
 * Badge colors mapped to @wavetrak/theme values:
 * - bronzing (#D0A847): expressive.bronzing
 * - greenFlash (#76E694): expressive.greenFlash
 * - brandSecondary (#171717): brandSecondary / gray10
 * - premiumDroplet (#1E7432): no exact theme match
 */
const BADGE_COLORS = {
  premium_plus: {
    background: '#D0A847', // expressive.bronzing
    droplet: '#171717', // brandSecondary
  },
  premium: {
    background: '#76E694', // expressive.greenFlash
    droplet: '#1E7432', // no theme match
  },
};

/**
 * LTA (Limited Time Access) Badge Icon
 * - premium_plus: Gold bookmark badge with dark droplet
 * - premium: Green bookmark badge with dark green droplet (used for Premium and Premium with Ads)
 */
const LtaBadgeIcon: React.FC<LtaBadgeIconProps> = ({ variant = 'premium' }) => {
  const colors = BADGE_COLORS[variant];

  return (
    <svg
      width="20"
      height="24"
      viewBox="0 0 20 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-label={`${variant === 'premium_plus' ? 'Premium+' : 'Premium'} badge`}
    >
      {/* Bookmark background */}
      <path
        d="M0 1.66667C0 0.746192 0.746192 0 1.66667 0H18.3333C19.2538 0 20 0.746192 20 1.66667V24L10 18.5532L0 24V1.66667Z"
        fill={colors.background}
      />
      {/* Surfline water droplet */}
      <path
        d="M13.772 8.89929C13.223 7.29728 10 3.39999 10 3.39999C10 3.39999 6.77652 7.29775 6.22756 8.90023C6.08023 9.3303 6 9.79309 6 10.2751C6 12.553 7.79102 14.4 10 14.4C12.209 14.4 14 12.553 14 10.2751C14 9.79216 13.9198 9.32936 13.772 8.89929ZM8 10.9618C7.63191 10.9618 7.33318 10.6542 7.33318 10.2741C7.33318 8.75531 8.5272 7.52447 9.99955 7.52447C10.2298 7.52447 10.4533 7.55485 10.6664 7.61095C9.51632 7.91621 8.66637 8.99325 8.66637 10.2741C8.66682 10.6542 8.36854 10.9618 8 10.9618ZM10 13.0242C9.76972 13.0242 9.54624 12.9943 9.33318 12.9378C10.4832 12.6325 11.3332 11.5559 11.3332 10.2746C11.3332 9.895 11.6315 9.58694 12 9.58694C12.3681 9.58694 12.6668 9.89453 12.6668 10.2746C12.6668 11.7934 11.4728 13.0242 10 13.0242Z"
        fill={colors.droplet}
      />
    </svg>
  );
};

export default LtaBadgeIcon;
